module.exports = __webpack_public_path__ + "img/ln.eb4e48e3.svg";